module.exports = __webpack_public_path__ + "media/images/emblems/Oron-coat_of_arms-12e081d6484a29ee31b75420136562bc.svg";